export default __webpack_public_path__ + "static/media/Affinity_Rev_01.12b431c4.svg";